import { Box, Typography, List, ListItem, ListItemIcon, ListItemText} from '@mui/material';
import PermIdentityRoundedIcon from '@mui/icons-material/PermIdentityRounded';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import BatteryCharging20OutlinedIcon from '@mui/icons-material/BatteryCharging20Outlined';
import BatteryChargingFullOutlinedIcon from '@mui/icons-material/BatteryChargingFullOutlined';

// LeftSideBar contains information about the room:
// roomID, modes, hints remaining, etc.
export default function RoomSideBar({roomID, mode, opMode, status, hints, opHints}) {

    return (
    <Box
        sx={{
          width: 380,
          borderRadius: 7,
          flexShrink: 0,
          backgroundColor: '#36454F',
          display: {
            xs: 'none',
            md: 'block',
          },
          top: { md: 96 },
          position: { md: 'sticky' },
        }}
      >

          <Typography sx={{ mt: 7, mb: 2, ml:4 }} variant="h4" align='left' component="div">
          Room Detail
          </Typography>

            <List dense={false} sx={{alignItems:'center'}}>
                <ListItem sx={{width: 'auto', mx: 2}}>
                  <ListItemIcon sx={{ mr: 2}}>
                    <HomeOutlinedIcon sx={{fontSize: '42px'}}/>
                  </ListItemIcon>
                  <ListItemText
                    primaryTypographyProps={{fontSize: '32px'}}
                    secondaryTypographyProps={{fontSize: '24px'}}
                    primary="Room ID: "
                    secondary={roomID}
                  />
                </ListItem>

                <ListItem sx={{width: 'auto', mx: 2}}>
                  <ListItemIcon sx={{ mr: 2}}>
                    <PermIdentityRoundedIcon sx={{fontSize: '42px'}}/>
                  </ListItemIcon>
                  <ListItemText
                    primaryTypographyProps={{fontSize: '28px'}}
                    secondaryTypographyProps={{fontSize: '24px'}}
                    primary="Your Mode:"
                    secondary={mode === 'Custom' ? `Custom (${hints} hints left)`: mode}
                  />
                </ListItem>

                <ListItem sx={{width: 'auto', mx: 2}}>
                  <ListItemIcon sx={{ mr: 2}}>
                    <PermIdentityRoundedIcon sx={{fontSize: '42px'}}/>
                  </ListItemIcon>
                  <ListItemText
                    primaryTypographyProps={{fontSize: '28px'}}
                    secondaryTypographyProps={{fontSize: '24px'}}
                    primary="Opponent's Mode:"
                    secondary={opMode === 'Custom' ? `Custom (${opHints} hints left)`: opMode}
                  />
                </ListItem>

                <ListItem sx={{width: 'auto', mx: 2}}>
                  <ListItemIcon sx={{ mr: 2}}>
                    {status === 'waiting' ? <BatteryCharging20OutlinedIcon sx={{fontSize: '42px'}}/> :  <BatteryChargingFullOutlinedIcon sx={{fontSize: '42px'}}/>}
                  </ListItemIcon>
                  <ListItemText
                    primaryTypographyProps={{fontSize: '28px'}}
                    secondaryTypographyProps={{fontSize: '18px'}}
                    primary="Status"
                    secondary={status === 'waiting' ? 'Waiting for your opponent...' : 'Ready to play'}
                  />
                </ListItem>
            </List>
    </Box>
    )
}
